// extracted by mini-css-extract-plugin
export default {"unknown_section":"Unknown_unknown_section__HGpm1","heading":"Unknown_heading__ZZDE0","blink":"Unknown_blink__1V9hf"};